import React from 'react';
import { ColorPropsEnum } from '../../types';
export var IconDocumentContent12 = _ref => {
  var {
    size,
    strokeWidth = 1.5,
    color = ColorPropsEnum.black
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    version: "1.1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: strokeWidth,
    stroke: color,
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,22c-2.761,0 -5,-2.239 -5,-5c0,-2.761 2.239,-5 5,-5c2.762,0 5,2.239 5,5c0,2.761 -2.238,5 -5,5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.222,15.889l-2.778,2.778l-1.666,-1.667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,12.417v-4.589c0,-0.53 -0.211,-1.039 -0.586,-1.414l-2.828,-2.828c-0.375,-0.375 -0.884,-0.586 -1.414,-0.586h-9.172c-1.105,0 -2,0.895 -2,2v14c0,1.105 0.895,2 2,2h9.003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,8h-4c-0.552,0 -1,-0.448 -1,-1v-4"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0,0h24v24h-24Z"
  }));
};
//# sourceMappingURL=IconDocumentContent12.js.map